import { Box, Grid, styled, Typography } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { imagesWEBP } from "../../constants/webpImages";

const CustomLoanProcess = styled(Box)(({ theme }) => ({
  background: "#FFF8F9",
  padding: "44px",
  margin: "auto",
  ".heading": {
    marginBottom: "12px",
    fontSize: "24px",
    fontWeight: "700",
  },
  ".grid-container": {
    justifyContent: "space-between",
  },
  ".grid-item": {
    flexDirection: "column",
    minWidth: "500px",
    maxWidth: "500px",
    justifyContent: "center",
  },
  ".description_box": {
    padding: "12px",
  },
  ".step_heading": {
    fontSize: "20px",
    fontWeight: "600",
  },
  ".step_subtext": {
    fontSize: "16px",
  },
  ".stepImg": {
    objectFit: "contain",
    width: "100%",
    maxHeight: "180px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "30px 18px",
    margin: "auto",
    ".grid-item": {
      flexDirection: "row",
      maxWidth: "100%",
      minWidth: "280px",
    },
    ".grid-item.reverse": {
      flexDirection: "row-reverse",
      maxWidth: "100%",
      minWidth: "280px",
    },
    ".description_box": {
      width: "60%",
    },
    ".stepImg": {
      width: "50%",
      maxHeight: "none",
    },
    ".step_heading": {
      fontSize: "16px",
    },
    ".step_subtext": {
      fontSize: "12px",
    },
  },
}));
const LoanProcess = () => {
  return (
    <CustomLoanProcess>
      <Typography className="heading">Our Super-Quick Loan Process</Typography>
      <Grid container className="grid-container">
        <Grid item sm={12} md={6} lg={6} className="grid-item">
          <LazyLoadImage src={imagesWEBP?.loanProcess[0]} className="stepImg" alt="loan process"/>
          <Box className="description_box">
            <Typography className="step_heading">Step 1</Typography>
            <Typography className="step_subtext">
              Choose a vehicle, specify your location/state, and provide your
              contact number via our website.
            </Typography>
          </Box>
        </Grid>
        <Grid item sm={12} md={6} lg={4} className="grid-item reverse">
          <LazyLoadImage src={imagesWEBP?.loanProcess[1]} className="stepImg" alt="loan process"/>
          <Box className="description_box">
            <Typography className="step_heading">Step 2</Typography>
            <Typography className="step_subtext">
              You will receive a call back within 15 minutes.
            </Typography>
          </Box>
        </Grid>
        <Grid item sm={12} md={6} lg={4} className="grid-item">
          <LazyLoadImage src={imagesWEBP?.loanProcess[2]} className="stepImg" alt="loan process"/>
          <Box className="description_box">
            <Typography className="step_heading">Step 3</Typography>
            <Typography className="step_subtext">
              Share your KYC documents with our representative for eligibility
              check.
            </Typography>
          </Box>
        </Grid>
        <Grid item sm={12} md={6} lg={4} className="grid-item reverse">
          <LazyLoadImage src={imagesWEBP?.loanProcess[3]} className="stepImg" alt="loan process"/>
          <Box className="description_box">
            <Typography className="step_heading">Step 4</Typography>
            <Typography className="step_subtext">
              Once KYC is done, Turno will request for further finance related
              documents. 
            </Typography>
          </Box>
        </Grid>

        <Grid item sm={12} md={6} lg={4} className="grid-item">
          <LazyLoadImage src={imagesWEBP?.loanProcess[4]} className="stepImg" alt="loan process"/>
          <Box className="description_box">
            <Typography className="step_heading">Step 5</Typography>
            <Typography className="step_subtext">
              Get the loan disbursement in just 48 hours.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </CustomLoanProcess>
  );
};

export default LoanProcess;
